export default __webpack_public_path__ + "static/media/largeImg.9e5b0228.jpg";